import React, {useCallback, useContext, useEffect, useState} from "react";
import {LayoutSplashScreen} from "../_metronic/layout";
import {authContext} from "./AuthProvider";
import {getAction, getAgency, getCarrier, getDestinationFacility, getPrompt} from "../api/options";
import {useModal} from "./ModalProvider";

export const optionContext = React.createContext();

const OptionProvider = (props) => {
  const {getToken, authUser} = useContext(authContext);
  const [loading, setLoading] = useState(true);
  const [option, setOption] = useState({});
  const showModal = useModal();
  const refresh = useCallback(() => {
    (async () => {
      try {
        setLoading(true);
        if (authUser) {
          const token = await getToken();
          const promises = await Promise.all([
            getCarrier(token),
            getAction(token),
            getPrompt(token),
            getAgency(token),
            getDestinationFacility(token)
          ]);
          const [carrier, action, prompt, agency, destinationFacility] = promises.map((res) => res.data);
          setOption({
            carrier, action, prompt, agency, destinationFacility
          });
        }
      } catch(e) {
        const {response} = e;
        showModal("An Error occurred.", response.data);
      } finally {
        setLoading(false);
      }
    })();
  }, [authUser, getToken, showModal]);
  useEffect(() => {
    refresh();
  }, [refresh, authUser]);
  if (loading) return <LayoutSplashScreen/>;
  return (
    <optionContext.Provider
      value={{option, refreshOption: refresh}}
    >
      {props.children}
    </optionContext.Provider>
  );
};

export default OptionProvider;
